import { FORM_FIELD_TYPES, MAX_UPLOAD_FILE_SIZE } from '../constants/message';

export function getUploadError(error, text) {
    const invalidFile = error.status === 415;
    const fileTooLarge = error.status === 413;
    const virusDetected = error.status === 400 && error.code === 'virus_detected';

    let bannerText;

    if (invalidFile) {
        bannerText = text.fileTypeError;
    } else if (fileTooLarge) {
        bannerText = getFileTooLargeText(text);
    } else if (virusDetected) {
        bannerText = text.uploadVirusError;
    }

    return {
        shouldRemoveMessage: invalidFile || fileTooLarge || virusDetected,
        bannerText,
    };
}

export function getFileTooLargeText(text) {
    return text.fileTooLargeError.replace('{size}', MAX_UPLOAD_FILE_SIZE.READABLE);
}

export function getFormFieldErrorMessage(error, formErrors) {
    const validations = {
        invalidEmail: ['should match format "email"', () => formErrors.formErrorInvalidEmail],
        noLongerThan: [
            'should not be longer than ([0-9]+) characters',
            (num) => formErrors.formErrorNoLongerThan.replace('{characters}', num),
        ],
        noShorterThan: [
            'should not be shorter than ([0-9]+) characters',
            (num) => formErrors.formErrorNoShorterThan.replace('{characters}', num),
        ],
    };

    if (!error || !error.description) {
        return formErrors.formErrorUnknown;
    }

    // This contains a regex of field choices, e.g. (?:text)|(?:email)|(?:select)
    const fieldChoicesRegex = Object.keys(FORM_FIELD_TYPES)
        .map((key) => `(?:${FORM_FIELD_TYPES[key]})`)
        .join('|');
    // This builds a regex such that it will catch an AJV error like '.email: should match format "email"'
    const validateError = (validation) =>
        new RegExp(`\\.(?:${fieldChoicesRegex}): ${validation}`).exec(error.description);

    for (const [validation, getMessage] of Object.values(validations)) {
        const error = validateError(validation);

        if (error) {
            return getMessage(error[1]);
        }
    }

    return formErrors.formErrorUnknown;
}
